import React, { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../utils/Loading";
import { useAuthContext } from "../hooks/useAuthContext";
import { Link } from "react-router-dom";
import { format, set } from "date-fns";
import Swal from "sweetalert2";
import { USERS_BASE_URL } from "../services/SignUpService";
import { getRoleDisplay } from "../utils/getRoleDisplay";

const UsersList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const { user } = useAuthContext();
  console.log("Logged in User Details: " + user);

  // Function to fetch all users
  const getAllUsers = async () => {
    try {
      const response = await axios.get(`${USERS_BASE_URL}/api/users/list`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      setUsersList(response.data); // Set the users list data
      console.log(response.data);
    } catch (error) {
      if (error.response) {
        setError(
          error.response.data.message ||
            "Something went wrong. Unable to fetch users data!"
        );
      } else if (error.request) {
        setError(
          "No response received from the server. Unable to fetch users data!"
        );
      } else {
        console.log(error.message);
        setError(error.message || "Unable to display users data!");
      }
    } finally {
      setLoading(false); // Set loading to false after fetching data
    }
  };

  // Function to delete a user
  const deleteUser = async (e, _id) => {
    e.preventDefault();

    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmResult.isConfirmed) {
        await axios.delete(`${USERS_BASE_URL}/api/users/list/delete/${_id}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });

        Swal.fire({
          title: "Deleted!",
          text: "User has been deleted.",
          icon: "success",
          timer: 2000,
        });

        getAllUsers(); // Reload users list right away
      }
    } catch (error) {
      console.error("Error deleting user: ", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to delete user!",
        icon: "error",
        timer: 2000,
      });
    }
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <section className="user-list">
      <div className="container">
        {/* Display total number of users */}
        {!loading && !error && usersList.length > 0 && (
          <>
            <div className="users_lsit text-centerx">
              <i className="fa fa-users"></i> &nbsp;
              <span>{usersList.length}</span>
              <h6>Total Users</h6>
            </div>
          </>
        )}

        {loading ? (
          <Loading />
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : usersList.length === 0 ? (
          <div className="alert alert-info">
            <p>No users found!</p>
          </div>
        ) : (
          <>
            <h1 className="bg-white mt-4 p-2">
              Users List
              <hr />
            </h1>
            <div className="row">
              <div className="col">
                <div className="table-responsive">
                  <table className="table table-striped table-bordered table-md table-hover">
                    <thead className="table-dark">
                      <tr>
                        <th scope="col">Avatar</th>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">User Roles</th>
                        <th scope="col">Admin</th>
                        <th scope="col">Verified</th>
                        <th scope="col">Joined At</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersList.map((user) => (
                        <tr key={user._id}>
                          <td>
                            <img
                              src="https://i.pravatar.cc/50"
                              alt="user avatar"
                              className="img-fluid rounded-circle"
                            />
                          </td>
                          <td>
                            <Link
                              to={`/api/dashboard/user-profile/${user._id}`}
                            >
                              {user && user.firstName}
                            </Link>
                          </td>
                          <td>{user && user.lastName}</td>
                          <td>{user && user.email}</td>
                          <td>
                            {user && user.isAdmin ? (
                              <span className="text-dark text-lowercase">
                                {/* {user.role} */}
                                {user.role.join(", ")}
                              </span>
                            ) : (
                              <span className="text-danger">
                                {getRoleDisplay(user) || ""}
                              </span>
                            )}
                          </td>
                          {/* <td>
                          {user.role && user.role.length > 0 ? (
                          user.role.map((role, index) => (
                          <span
                          key={index}
                          className="badge bg-primary d-block m-1"
                          >
                          {index + 1}. {role}

                          </span>
                          ))
                          ) : (
                          <span className="text-danger">No Roles</span>
                          )}

                          </td> */}

                          <td>
                            {user && user.isAdmin ? (
                              <span className="text-success">YES</span>
                            ) : (
                              <span className="text-danger">NO</span>
                            )}
                          </td>
                          <td>
                            {user && user.isVerified ? (
                              <span className="text-success">YES</span>
                            ) : (
                              <span className="text-danger">NO</span>
                            )}
                          </td>
                          <td className="text-muted created_at">
                            {format(new Date(user.createdAt), "MMMM d, yyyy")}
                          </td>
                          <td className="text-center">
                            <Link
                              to={`/api/dashboard/user-profile/${user._id}`}
                              className="btn btn-outline-primary btn-sm"
                            >
                              <i className="fa fa-pencil"></i>
                            </Link>
                            {user && !user.isAdmin && (
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={(e) => deleteUser(e, user._id)}
                                disabled={user && user.isAdmin}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default UsersList;
